<template>
    <div>
        <b-modal id="WLBLItemModal" size="lg" class="modal has-overflow" @shown="FilterDecisions">
          <div class="e-loader-back" v-if="loading">
            <div class="e-loader-content">
              <div class="ball-clip-rotate-multiple">
                <div></div>
                <div></div>
              </div>
              <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
            </div>
          </div>
          <template v-slot:modal-header>
          <div class="w-100">
            <h6 class="e-mtavr-17 e-bold modal-title">გთხოვთ აირჩიოთ</h6>
          </div>
          </template>
          <b-form>
            <div class="row">
              <div class="col col-12">
                <b-form-group>
                  <b-form-radio-group size="sm" v-model="SelectedPEP" multiple="false" @change="logSelected">
                    <b-form-radio
                    :disabled="SelectedFLS.length > 0"
                    v-for="decType in PEPDecs" :key="decType.$index"
                    inline
                      :value="decType"
                      >{{decType.type}}</b-form-radio>
                  </b-form-radio-group>
                  <hr class="mt-1 mb-1">
                  <b-form-checkbox-group size="sm" inline v-model="decision" multiple @change="logSelected">
                      <b-form-checkbox
                      :disabled="SelectedFLS.length > 0"
                      v-for="decType in SANDecs" :key="decType.$index"
                      inline
                      :value="decType"
                      >{{decType.type}}</b-form-checkbox>
                  </b-form-checkbox-group>
                  <hr class="mt-1 mb-1">
                  <b-form-checkbox-group size="sm" inline v-model="decision" multiple @change="logSelected">
                      <b-form-checkbox
                      :disabled="SelectedFLS.length > 0"
                      v-for="decType in OTHDecs" :key="decType.$index"
                      inline
                      :value="decType"
                      >{{decType.type}}</b-form-checkbox>
                  </b-form-checkbox-group>
                  <hr class="mt-1 mb-1">
                  <b-form-checkbox-group size="sm" v-model="SelectedFLS" multiple @change="logSelected" v-if="newRecord.ListType === 'Approve' || DataStream.ListType === 'Approve'">
                    <b-form-checkbox
                    v-for="decType in FLSDecs" :key="decType.$index"
                    inline
                      :value="decType"
                      >{{decType.type}}</b-form-checkbox>
                      <br>
                      <label class="e-nusx-8"><small>შენიშვნა:  მონიშნეთ იმ შემთხვევაში თუ კლიენტის მონაცემები არ ემთხვევა ბაზაში არსებულ მონაცემებს.</small></label>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
              <div class="col-md-12 col-lg-12 col-sm-12 mt-1 e-ts-07rem">
                <hr class="mt-1 mb-1">
                  <b-form-group label="კომენტარი" class="col-12 e-nusx-8 e-bold text-muted pl-0">
                    <b-textarea :rows="3" v-model="newRecord.comment"/>
                  </b-form-group>
              </div>
            </div>
          </b-form>
          <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              size="sm"
              variant="btn btn-primary"
              @click="save()"
              class="float-right e-mtavr-17"
            >შენახვა</b-button>
            <b-button
              size="sm"
              variant="btn btn-secondary"
              @click="close('WLBLItemModal')"
              class="float-right e-mtavr-17 mr-2"
            >გაუქმება</b-button>
          </div>
          </template>
        </b-modal>
    </div>
</template>

<script>
import BaseService from '@/backend/vue-axios/axios.js'
import 'loaders.css/loaders.css'
import 'spinkit/spinkit.css'
import moment from 'moment'
export default {
  props: ['DataStream'],
  data () {
    return {
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      SelectedFLS: [],
      SelectedPEP: '',
      testDecision: [],
      showPop: false,
      fullCountryList: [],
      filteredCountriesList: [],
      loading: false,
      juridicalStatuses: [],
      newRecord: {},
      // currentUser: this.$store.getters.GetCurrentUser,
      decisionTypes: this.$store.getters.GetDecisionTypes,
      decision: [],
      decisionResultItem: [],
      thisRequestID: this.$route.query.clientRequestId
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.GetCurrentUser
    },
    PEPDecs () {
      return this.decisionTypes.filter(item => item.groupName === 'PEP')
    },
    SANDecs () {
      return this.decisionTypes.filter(item => item.groupName === 'Sanctions')
    },
    OTHDecs () {
      return this.decisionTypes.filter(item => item.groupName === 'Other')
    },
    FLSDecs () {
      return this.decisionTypes.filter(item => item.groupName === 'False')
    }
  },
  methods: {
    FilterDecisions () {
      if (this.DataStream.ListType === 'Approve') {
        this.decisionTypes = this.$store.getters.GetDecisionTypes
        this.decisionTypes = this.decisionTypes.filter(item => item.type !== 'UN Sanctions')
      } else if (this.DataStream.ListType === 'Blocked') {
        this.decisionTypes = this.$store.getters.GetDecisionTypes
        this.decisionTypes = this.decisionTypes.filter(item => item.type !== 'False')
      }
    },
    logSelected () {
      if (this.SelectedFLS.length > 0) {
        this.decision = []
        this.SelectedPEP = ''
      }
    },
    save () {
      this.loading = true
      if (this.newRecord.ListType === 'white' || this.DataStream.ListType === 'white') {
        BaseService.AddWhiteListRecord(this.header, this.newRecord)
          .then(res => {
            if (res.data.success) {
              this.loading = false
              this.newRecord = {}
              this.$bvModal.hide('WLBLItemModal')
              this.$emit('RecordAdded')
            }
          })
      } else if (this.newRecord.ListType === 'Black' || this.DataStream.ListType === 'Black') {
        BaseService.AddBlackListRecord(this.header, this.newRecord)
          .then(res => {
            if (res.data.success) {
              this.loading = false
              this.newRecord = {}
              this.$bvModal.hide('WLBLItemModal')
              this.$emit('RecordAdded')
            }
          })
      } else if (this.newRecord.ListType === 'Approve' || this.DataStream.ListType === 'Approve') {
        if (this.SelectedFLS.length > 0) {
          this.decision = []
          this.decision.push(this.SelectedFLS[0])
        } else
        if (this.SelectedPEP.id > 0) {
          this.decision.push(this.SelectedPEP)
        }
        this.decision.forEach(res => {
          this.decisionResultItem.push({
            id: 0,
            result: res.type,
            // requestId: this.newRecord.requestId,
            requestId: Number(this.thisRequestID ? this.thisRequestID : this.newRecord.requestId),
            decisionResultTypeId: res.id
          })
        })
        if (this.newRecord.comment !== '') {
          var commentItem = {
            id: 0,
            commentText: this.newRecord.comment,
            userId: this.currentUser.id,
            userName: this.currentUser.userName,
            recDate: moment(Date.now()).format(),
            requestId: Number((this.thisRequestID ? parseInt(this.thisRequestID) : parseInt(this.newRecord.requestId))),
            deleteStatus: false,
            organisationUserId: 0
          }
          BaseService.AddComment(this.header, commentItem)
            .then(res => {
              if (res.data.success) {
                this.newRecord.comment = ''
                if (this.decisionResultItem.length > 0) {
                  this.addDecision()
                  this.setRequestStatus(this.thisRequestID ? this.thisRequestID : this.newRecord.requestId, 5)
                } else {
                  this.setRequestStatus(this.thisRequestID ? this.thisRequestID : this.newRecord.requestId, 5)
                }
              }
            })
        } else {
          if (this.decisionResultItem.length > 0) {
            this.addDecision()
            this.setRequestStatus(this.thisRequestID ? this.thisRequestID : this.newRecord.requestId, 5)
          } else {
            this.setRequestStatus(this.thisRequestID ? this.thisRequestID : this.newRecord.requestId, 5)
          }
        }
      } else if (this.newRecord.ListType === 'Blocked' || this.DataStream.ListType === 'Blocked') {
        // eslint-disable-next-line no-debugger
        debugger
        if (this.SelectedFLS.length > 0) {
          this.decision = this.SelectedFLS[0]
        } else
        if (this.SelectedPEP.id > 0) {
          this.decision.push(this.SelectedPEP)
        }
        this.decision.forEach(res => {
          this.decisionResultItem.push({
            id: 0,
            result: res.type,
            // requestId: this.newRecord.requestId,
            requestId: Number(this.thisRequestID ? this.thisRequestID : this.newRecord.requestId),
            decisionResultTypeId: res.id
          })
        })
        if (this.newRecord.comment !== '') {
          console.log(this.$route.query.clientRequestId)
          var commentItemBLK = {
            id: 0,
            commentText: this.newRecord.comment,
            userId: this.currentUser.id,
            userName: this.currentUser.userName,
            recDate: moment(Date.now()).format(),
            requestId: Number(this.thisRequestID ? this.thisRequestID : this.newRecord.requestId),
            deleteStatus: false,
            organisationUserId: 0
          }
          BaseService.AddComment(this.header, commentItemBLK)
            .then(res => {
              if (res.data.success) {
                this.newRecord.comment = ''
                if (this.decisionResultItem.length > 0) {
                  this.addDecision()
                  this.setRequestStatus(this.thisRequestID ? this.thisRequestID : this.newRecord.requestId, 4)
                } else {
                  this.setRequestStatus(this.thisRequestID ? this.thisRequestID : this.newRecord.requestId, 4)
                }
              }
            })
        } else {
          if (this.decisionResultItem.length > 0) {
            this.addDecision()
            this.setRequestStatus(this.thisRequestID ? this.thisRequestID : this.newRecord.requestId, 4)
          } else {
            this.setRequestStatus(this.thisRequestID ? this.thisRequestID : this.newRecord.requestId, 4)
          }
        }
      }
    },
    close (id) {
      this.$bvModal.hide(id)
      this.decisionResultItem = []
      this.decision = []
      this.SelectedPEP = ''
      this.SelectedFLS = []
    },
    addDecision () {
      console.log(this.decisionResultItem)
      // eslint-disable-next-line no-debugger
      debugger
      BaseService.AddDecisionResults(this.header, this.decisionResultItem)
        .then(res => {
          // console.log(res)
          if (res.data.success) {
            this.decisionResultItem = []
          } else {
            this.$swal({
              icon: 'danger',
              title: 'შეცდომა!',
              html: '<span class="e-nusx-8 e-ts-09rem">თქვენი გადაწყვეტილების შენახვისასმოხდა სისტემური შეცდომა, გთხოვთ დაუკავშირდით CDC Screening-ის მხარდაჭერის ჯგუფს!</span>',
              showCancelButton: false,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: 'გასაგებია',
              heightAuto: false,
              keydownListenerCapture: true
            })
          }
        })
    },
    setRequestStatus (recId, statusId) {
      // // eslint-disable-next-line no-debugger
      // debugger
      BaseService.SetRequestStatus(this.header, recId, statusId)
        .then(res => {
          if (res.data.success) {
            // // eslint-disable-next-line no-debugger
            // debugger
            this.investigatingRequest = res.data.result.request
            this.close('WLBLItemModal')
            this.$forceUpdate()
            this.$emit('RecordAdded')
            this.$emit('close')
          } else { console.log(res) }
        })
    }
  },
  mounted () {
    this.fullCountryList = this.$store.getters.GetCountriesList
    this.juridicalStatuses = this.$store.getters.GetjuridicalStatuses
    this.newRecord = this.$store.getters.getWHBL_item_sent
    this.newRecord.birthDate = this.newRecord.birthDate === null ? null : moment.utc(this.newRecord.birthDate, 'DD.MM.YYYY').format()
  }
}
</script>
